import { c as _c } from "react/compiler-runtime";
// Sign in. Served by an instance (the usual case: hq:Decision/instance-own-origin): this instance only, with a passkey
// on its /auth pages (they come back here, and the browser session becomes this app's session) or a token as the
// fallback. On the dev server (BUN_PUBLIC_API_BASE elsewhere): the instance field and a token.
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { API_BASE_DEFAULT, SAME_ORIGIN, USE_MOCKS } from "@/api/client";
import { ErrorLine } from "@/components/error-line";
import { Field } from "@/components/field";
import { LinkButton } from "@/components/link-button";
import { useAuth } from "@/store";
export function LoginPage() {
  const $ = _c(49);
  const {
    t
  } = useTranslation();
  const {
    token,
    signIn,
    signInBrowser,
    busy,
    error,
    creds
  } = useAuth();
  const [value, setValue] = useState("");
  const own = SAME_ORIGIN && !USE_MOCKS;
  let t0;
  if ($[0] !== creds?.api) {
    t0 = () => new URLSearchParams(location.search).get("instance") ?? creds?.api ?? (own ? "" : API_BASE_DEFAULT);
    $[0] = creds?.api;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [instance, setInstance] = useState(t0);
  const [checking, setChecking] = useState(own);
  let t1;
  if ($[2] !== signInBrowser || $[3] !== token) {
    t1 = () => {
      if (!own || token) {
        return;
      }
      fetch("/auth/setup", {
        redirect: "manual"
      }).then(_temp, _temp2);
      signInBrowser().finally(() => setChecking(false));
    };
    $[2] = signInBrowser;
    $[3] = token;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (token) {
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Navigate to="/" replace={true} />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (checking) {
    let t3;
    if ($[7] !== t) {
      t3 = t("app.title");
      $[7] = t;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    let t4;
    if ($[9] !== t3) {
      t4 = <div className="flex min-h-screen items-center justify-center p-6 font-mono text-xs opacity-60">{t3}</div>;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  let t3;
  if ($[11] !== instance || $[12] !== signIn || $[13] !== value) {
    t3 = e => {
      e.preventDefault();
      signIn(own ? API_BASE_DEFAULT : instance, value);
    };
    $[11] = instance;
    $[12] = signIn;
    $[13] = value;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== t) {
    t4 = t("app.title");
    $[15] = t;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <div className="mb-2 font-mono text-xs opacity-60">{t4}{own ? ` · ${location.host}` : ""}</div>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== instance || $[20] !== t) {
    t6 = own ? isSecureContext && <div className="mb-3"><LinkButton underline={true} autoFocus={true} onClick={_temp3}>{t("auth.passkey")}</LinkButton></div> : <Field t="instance" className="mono" aria-label={t("auth.instance")} placeholder="https://hq.example.com" autoComplete="off" value={instance} onChange={e_0 => setInstance(e_0.target.value)} />;
    $[19] = instance;
    $[20] = t;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t) {
    t7 = t("auth.token");
    $[22] = t;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t) {
    t8 = own ? t("auth.orToken") : t("auth.token");
    $[24] = t;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_1 => setValue(e_1.target.value);
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== busy || $[28] !== instance || $[29] !== value) {
    t10 = busy || !value.trim() || !own && !instance.trim();
    $[27] = busy;
    $[28] = instance;
    $[29] = value;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== t) {
    t11 = t("auth.signIn");
    $[31] = t;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <LinkButton type="submit" disabled={t10}>{t11}</LinkButton>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t12 || $[37] !== t7 || $[38] !== t8 || $[39] !== value) {
    t13 = <Field t="token" className="mono" type="password" aria-label={t7} placeholder={t8} autoComplete="off" autoFocus={!own} value={value} onChange={t9} action={t12} />;
    $[36] = t12;
    $[37] = t7;
    $[38] = t8;
    $[39] = value;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  let t14;
  if ($[41] !== error) {
    t14 = <ErrorLine className="h-4">{error}</ErrorLine>;
    $[41] = error;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  let t15;
  if ($[43] !== t13 || $[44] !== t14 || $[45] !== t3 || $[46] !== t5 || $[47] !== t6) {
    t15 = <div className="flex min-h-screen items-center justify-center p-6"><form className="flex w-full max-w-xs flex-col gap-2" onSubmit={t3}>{t5}{t6}{t13}{t14}</form></div>;
    $[43] = t13;
    $[44] = t14;
    $[45] = t3;
    $[46] = t5;
    $[47] = t6;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  return t15;
}
function _temp3() {
  return location.href = `/auth/login?next=${encodeURIComponent("/login")}`;
}
function _temp2() {}
function _temp(r) {
  return r.status === 200 && location.replace("/auth/setup");
}